import Constants from "../utils/consts";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function updateLezione(
  uname,
  token,
  id_lezione,
  date,
  hour,
  minutes,
  durata,
  altri_corsi,
  id_corso,
  id_materia,
  id_aula,
  id_insegnanti,
  pagamento_quota // Nuovo parametro per il flag pagamento quota
) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "updateLezione.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);
        try {
          const resp = JSON.parse(body.toString());
          resolve(resp);
        } catch (e) {
          resolve({
            result: "err",
            description: "Errore durante l'elaborazione: " + e.message,
          });
        }
      });

      res.on("error", function(error) {
        console.error(error);
        reject(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      id_lezione: id_lezione,
      date: date,
      hour: hour,
      minutes: minutes,
      durata: durata,
      altri_corsi: altri_corsi,
      id_corso: id_corso,
      id_materia: id_materia,
      id_aula: id_aula,
      id_insegnanti: id_insegnanti,
      pagamento_quota: pagamento_quota, // Passato al backend
    });

    req.write(postData);

    req.end();
  });
}
